import Head from "next/head"
import PropTypes from "prop-types"
import Publisher from "./Publisher"
import serializeJsonLd from "./serializeJsonLd"
const { Duration } = require("luxon")
const { normalizePlayerUrl } = require("lib/videoPlayerUrl")
const { buildVideoObject } = require("./videoObject")

const Video = ({
  title,
  description,
  images,
  uploadDate,
  publicationDate,
  movieMediaId,
  duration,
  mediaUrl,
}) => {
  const isoDuration = Number.isFinite(duration)
    ? Duration.fromMillis(duration * 1000).toISO()
    : null
  const embedUrl = normalizePlayerUrl(mediaUrl)
  const video = buildVideoObject({
    title,
    description,
    images,
    uploadDate,
    publicationDate,
    movieMediaId,
    duration: isoDuration,
    embedUrl,
    publisher: Publisher(),
  })

  if (video === null) {
    return null
  }

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: serializeJsonLd(video),
        }}
      />
    </Head>
  )
}

Video.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.string),
  uploadDate: PropTypes.string,
  publicationDate: PropTypes.string,
  movieMediaId: PropTypes.number,
  duration: PropTypes.number,
  mediaUrl: PropTypes.string,
}

export default Video
